import basic from "./basic";
import integrations from "./integrations";

//Notification Icons - https://material.io/tools/icons/?style=baseline
export default {
    ...basic,
    ...integrations
};